import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { subscriptionPlans } from '@/common/constants'
import { preferences } from '@/configuration/pages/ConfigurationPage/constants'
import { issueExchangeStatus } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/constants'
import { exchangeOrdersAutomaticCreationValues } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/constants'
import { allowedExchangeMethodsIncludesSomeVariantsType } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/helpers'

import { exchangeErrorResolutionTypes } from './constants'

const ExchangeErrorResolutionSelector = ({
  value,
  onChange,
  issueExchangeAtStatus,
  allowedPreferences,
  exchangeOrdersAutomaticCreation,
  allowedExchangeMethods,
  subscriptionPlan,
  disabled,
}) => {
  const { t } = useTranslation()

  if (
    !allowedPreferences.includes(preferences.allowedExchangeMethods) ||
    !allowedPreferences.includes(preferences.exchangeOrdersAutomaticCreation) ||
    exchangeOrdersAutomaticCreation !== exchangeOrdersAutomaticCreationValues.automatic ||
    !allowedExchangeMethodsIncludesSomeVariantsType(allowedExchangeMethods) ||
    issueExchangeAtStatus === issueExchangeStatus.inProgress
  ) {
    return null
  }

  return (
    <ComboBox
      fullWidth
      value={value}
      disabled={disabled || subscriptionPlan === subscriptionPlans.basic}
      handleChange={e => onChange(e.target.value)}
      label={t('Resolución error pedidos de cambio')}
      menuItems={[
        {
          label: t('Gestionar manualmente'),
          value: exchangeErrorResolutionTypes.manual,
        },
        {
          label: t('Emitir crédito en tienda automáticamente (aplica crédito adicional)'),
          value: exchangeErrorResolutionTypes.refund,
        },
      ]}
    />
  )
}

export default ExchangeErrorResolutionSelector
